const getOrderParams = ( selected ) => {
	let orderby, order;
	switch ( selected ) {
	case 'default':
		orderby = 'date';
		order = 'DESC';
		break;
	case 'name_asc':
		orderby = 'title';
		order = 'ASC';
		break;
	case 'name_desc':
		orderby = 'title';
		order = 'DESC';
		break;
	case 'price_desc':
		orderby = 'price';
		order = 'DESC';
		break;
	case 'price_asc':
		orderby = 'price';
		order = 'ASC';
		break;
	case 'rating_desc':
		orderby = 'rating';
		order = 'DESC';
		break;
	case 'rating_asc':
		orderby = 'rating';
		order = 'ASC';
		break;
	default:
		orderby = 'date';
		order = 'DESC';
		break;
	}

	return { orderby, order };
};

export { getOrderParams };
